/**
 * Lazy load images. For IE11 and Safari, the intersection-observer polyfill is required.
 * Include this in your theme config: "node_modules/intersection-observer/intersection-observer.js",
 * 
 * Each image needs attribute data-image-lazy, which changes to data-image-loaded after load.
 * Each image needs data-src. For responsive images, each image needs data-sizes and data-srcset.
 */
var initializeLazyLoader = function () {
	var lichenImageIntersectionObserver = new IntersectionObserver(function (changes) {
		changes.forEach(function (change) {
			var image = change.target;
			// check the lazy attribute and if it's intersecting the viewport
			if (image.hasAttribute('data-image-lazy') && change.intersectionRatio > 0) {
				// remove lazy attribute
				image.removeAttribute('data-image-lazy');
				// set sizes
				if (image.hasAttribute('data-sizes')) {
					image.setAttribute('sizes', image.getAttribute('data-sizes'));
					image.removeAttribute('data-sizes');
				}
				// set srcset
				if (image.hasAttribute('data-srcset')) {
					image.setAttribute('srcset', image.getAttribute('data-srcset'));
					image.removeAttribute('data-srcset');
				}
				// set src
				image.setAttribute('src', image.getAttribute('data-src'));
				image.removeAttribute('data-src');
				// on image load event
				image.onload = function () {
					// set loaded attribute
					image.setAttribute('data-image-loaded', '');
					// stop observing
					lichenImageIntersectionObserver.unobserve(image);
				};
			}
		});
	}, { threshold: [0, 0.5, 1] });
	// observe all images with attribute data-image-lazy
	Array.prototype.map.call(document.querySelectorAll('[data-image-lazy]'), function (image) {
		lichenImageIntersectionObserver.observe(image);
	});
};

document.addEventListener('lichen:loaded', initializeLazyLoader);
